import React from 'react';
import PropTypes from 'prop-types';
import { createCallList } from 'components/call_lists/api';

export default class CallListForm extends React.Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired
  };

  state = { newCallListName: null };

  createNewCallList = () => {
    const { onClose } = this.props;
    const { newCallListName } = this.state;

    const payload = { name: newCallListName };
    createCallList(payload, onClose);
  }

  setNewCallListName = (event) => {
    this.setState({ newCallListName: event.target.value });
  }

  render() {
    const { onClose } = this.props;
    return (
      <div>
        <label style={{ width: '100%' }} >
          Name: <br />
        </label>
        <input
          className="form-control"
          name="name"
          placeholder={"Enter a new name"}
          type="text"
          onChange={this.setNewCallListName}
        />
        <div className="mt-4">
          <button
            className="btn btn-cancel"
            name="cancel-button"
            onClick={() => onClose()}
          >
            Cancel
          </button>
          <button
            className="btn btn-save ml-3"
            name="create-queue-button"
            onClick={this.createNewCallList}
          >
            Create Call List
          </button>
        </div>
      </div>
    );
  }
}
